import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MdHelp as Help } from 'react-icons/md';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';

const mapStateToProps = function (store) {
  return {
    tenantProfile: store.tenantProfile,
  };
};

let TenantForwardingAddress = class extends Component {
  UNSAFE_componentWillMount() {
    this.setState({ dialogOpen: false });
  }

  toggleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  render() {
    const style = {
      table_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    const propertyFAQS =
      this.props.tenantProfile && this.props.tenantProfile.generalDetails
        ? this.props.tenantProfile.generalDetails.property_faqs
        : '';

    return (
      <span
        style={{
          cursor: 'pointer',
          verticalAlign: 'middle',
          float: 'right',
          display: 'inline',
        }}
      >
        {propertyFAQS && (
          <Help
            size={25}
            onClick={this.toggleDialog}
            style={{
              marginTop: '-9px',
              marginBottom: '-10px',
            }}
          />
        )}
        <Dialog
          fullScreen={this.props.fullScreen}
          open={this.state.dialogOpen}
          onClose={this.toggleDialog}
          aria-labelledby="property-faq"
          classes={{
            paper: 'form-dialog',
          }}
        >
          <DialogTitle id="property-faq">
            <h3 style={{ textAlign: 'center', margin: 0 }}>Property FAQs</h3>
          </DialogTitle>
          <DialogContent>
            <div className="row" style={style.table_header}>
              <div style={{ textAlign: 'center' }}>
                <span style={{ textAlign: 'center' }}>Frequently Asked Questions</span>
              </div>
            </div>
            <pre style={{ fontFamily: 'Circular', marginTop: '25px', fontSize: '14px' }}>
              {propertyFAQS}
            </pre>
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.toggleDialog}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              CLOSE
            </FlatButton>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
};

export default withMobileDialog()(connect(mapStateToProps, {})(TenantForwardingAddress));
